import { createUseStyles } from "react-jss";

export default createUseStyles({
  colorPicker: {
    margin: "1rem",
    padding: 0,
    width: "50px",
    height: "50px",
    outline: "none",
    border: "none",
    cursor: "pointer",
  },
});
